import { getShippingMethods } from '../shipping/shippingModule';
import { deliveryStepPreConditions, deliveryStepPostConditions } from './deliveryStepSelectors';
import { giftCardFieldNames } from '../item/newItemForm';
import { preferencesAreLoaded } from '../brand/brandSelectors';
import { catalogsAreLoaded } from '../catalogs/catalogSelectors';



const deliveryStepConfig = {
    component: () => import('./DeliveryStep'),
    flow: 'buy',
    isReady: (state) => {
        const preferencesLoaded = preferencesAreLoaded(state);
        const catalogsLoaded = catalogsAreLoaded(state);
        return preferencesLoaded && catalogsLoaded;
    },
    onExit: (dispatch, ownProps, values) => {
        const { isPlastic } = ownProps;

        if (isPlastic) {
            const mergedValues = values.merge({
                hasAccessory: !!values.get(giftCardFieldNames.ITEM_ACCESSORY, false)
            });
            dispatch(getShippingMethods(mergedValues, true));
        }
    },
    preConditions: deliveryStepPreConditions,
    postConditions: deliveryStepPostConditions
};

export default deliveryStepConfig;
